export type TestType = 'Oncho' | 'Brugia';

export interface Batch {
  id: number;
  lot_number: string;
  test_type: TestType;
  control_line_threshold: number;
  threshold1: number;
  threshold2?: number | null;
  threshold_percentage: number;
  expiry_date: Date;
  is_active: boolean;
}

export type CustomFieldType = 'NUMBER_ENTRY' | 'TEXT_ENTRY' | 'TEXT_PICKER' | 'BARCODE';

export interface CustomField {
  id: number;
  organisation: number;
  type: CustomFieldType;
  key: string;
  title: string;
  placeholder?: string;
  required: boolean;
  required_error?: string;
  validation_error?: string;
  regex?: string;
  range?: number[];
  options?: string[];
  default_index?: number;
}

export const customFieldTypeLabels = {
    NUMBER_ENTRY: 'Number',
    TEXT_ENTRY: 'Text',
    TEXT_PICKER: 'Text Picker',
    BARCODE: 'Barcode',
}
